import { Emblem, type EmblemName } from '../../../ui/brand/Emblems'
import { cx } from '../../../ui/cx'
import { CombatTooltip } from './CombatTooltip'

export function CombatAction({ name, description, emblem, cost, cooldown, selected, disabled, mana, onPick }: {
  name: string; description: string; emblem: EmblemName; cost: string; cooldown?: number
  selected: boolean; disabled: boolean; mana?: boolean; onPick: () => void
}) {
  return <CombatTooltip className="combat-action" name={name} description={description}
    note={`Цена / прирост: ${cost}${cooldown ? ` · Перезарядка: ${cooldown}` : ''}`} focusable={disabled}>
    {describedBy => <button type="button" role="radio" aria-label={`${name}: ${description}`} aria-checked={selected}
      aria-describedby={describedBy} disabled={disabled} className={cx('actbtn', selected && 'is-selected', disabled && 'is-disabled')} onClick={onPick}>
      <Emblem name={emblem} size={32} />
      <span className="visually-hidden">{name}: {description}</span>
      <i className={cx('actbtn__cost', mana && 'actbtn__cost--mana')} aria-hidden="true">{cost.replace(/ маны/g, '✧')}</i>
      {cooldown ? <span className="actbtn__cd" aria-hidden="true">{cooldown}</span> : selected && <span className="combat-action__selected" aria-hidden="true">✓</span>}
    </button>}
  </CombatTooltip>
}
